import React, { useState, useMemo } from "react";
import ButtonIconH from "../../components/ButtonIconH";

import "../css/DataGridView.css";

export default function DataGridView(props) {
  const [visibleCount, setVisibleCount] = useState(props.itemsIncrement);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  // --- LÓGICA DE ORDENACIÓN ---
  const handleSort = (key) => {
    let direction = "asc";
    // Si ya estamos ordenando por esta columna y es ascendente, cambiamos a descendente
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    // Reiniciamos la visibilidad al ordenar para volver al principio de la lista
    setVisibleCount(props.itemsIncrement);
    setSortConfig({ key, direction });
  };

  const sortedData = useMemo(() => {
    let sortableItems = [...props.data]; // Hacemos una copia para no mutar el array original

    if (sortConfig.key !== null) {
      sortableItems.sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        // Comprobación de nulos o indefinidos
        if (aValue === null || aValue === undefined) return 1;
        if (bValue === null || bValue === undefined) return -1;

        if (aValue < bValue) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [props.data, sortConfig]);

  // --- LÓGICA DE CARGA (Aplicada SOBRE los datos ya ordenados) ---
  const currentData = sortedData.slice(0, visibleCount);

  // Función para cargar más elementos
  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + props.itemsIncrement);
  };

  // 1. Calculamos la estructura del Grid basándonos en los anchos de la configuración
  const gridTemplateColumns = props.columns.map((col) => col.width || "1fr").join(" ");

  // 2. Creamos un objeto de estilo para aplicarlo a las filas y la cabecera
  const gridStyle = {
    display: "grid",
    gridTemplateColumns: gridTemplateColumns,
    gap: "16px", // Espacio entre columnas
  };

  return (
    <div className="dgv-container">
      {/* --- CABECERA --- */}
      <div className="dgv-table-header" style={gridStyle}>
        {props.columns.map((col, index) => {
          const isSorted = sortConfig.key === col.accessor;

          const headerClasses = [
            "dgv-table-header-item",
            col.sortable ? "is-sortable" : "",
            isSorted ? "is-sorted-active" : "",
          ]
            .join(" ")
            .trim();

          return (
            <span
              key={col.accessor || index}
              className={headerClasses}
              onClick={() => col.sortable && handleSort(col.accessor)}
            >
              <span className="dgv-header-text">{col.name}</span>
              {/* Indicador visual de ordenación */}
              {col.sortable && (
                <span className="dgv-sort-icon">
                  {isSorted ? (
                    // Si está ordenada, mostramos la flecha grande correspondiente
                    sortConfig.direction === "asc" ? (
                      "▲"
                    ) : (
                      "▼"
                    )
                  ) : (
                    // Si NO está ordenada, mostramos un pequeño "stack" de triángulos
                    <span className="dgv-stack">
                      <span>▲</span>
                      <span>▼</span>
                    </span>
                  )}
                </span>
              )}
            </span>
          );
        })}
      </div>
      {/* --- CUERPO --- */}
      <div className="dgv-table-body">
        {currentData.map((row, rowIndex) => {
          return (
            <div
              key={row[props.keyField] || rowIndex}
              className="dgv-table-data-row"
              style={gridStyle}
              onClick={() => {
                if (props.onRowClick) props.onRowClick(row);
              }}
            >
              {props.columns.map((col, colIndex) => (
                <span
                  key={`${row[props.keyField] || rowIndex}-${col.accessor || colIndex}`}
                  className="dgv-table-row-item"
                >
                  {row[col.accessor]}
                </span>
              ))}
            </div>
          );
        })}
      </div>
      {/* --- PIE DE TABLA: BOTÓN VER MÁS --- */}
      {visibleCount < props.data.length && (
        <div className="dgv-load-more-container">
          <ButtonIconH text="Ver más" onClick={handleLoadMore} />
          <span className="dgv-load-more-info">
            Mostrando {currentData.length} de {props.data.length}
          </span>
        </div>
      )}
    </div>
  );
}
